import { render } from "./App.vue?vue&type=template&id=f45aad86"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.css?vue&type=style&index=0&lang=css"

import exportComponent from "/codebuild/output/src016863213/src/lauracares/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__